export const enum SProvidersMutationsNames {
    SetList = "setServiceProviders",
    SetSelected = "setSelectedServiceProvider",
    SetError = "serviceProvidersError",
    ResetState = "resetState",
}

export const enum SProvidersActionsNames {
    FetchList = "fetchServiceProviders",
    SetSelected = "setSelectedServiceProvider",
    ResetState = "resetServiceProviderState",
}

export const enum SProvidersGettersNames {
    List = "serviceProvidersList",
    Selected = "selectedServiceProvider",
    IsSelected = "isSelectedServiceProvider",
}
